import clsx from 'classnames';
import Check from 'icons/lib/checkbox_round_2_48.svg';
import Info from 'icons/lib/info.svg';

import styles from './Information.module.scss';
import { InformationProps } from './types';

export const Information = ({
  arrow = false,
  children,
  className,
  icon = 'info',
  type = 'success',
}: InformationProps) => {
  const classNames = clsx(
    styles.information,
    {
      [styles[`information--${type}`]]: !!type,
      [styles[`information--arrow`]]: !!arrow,
    },
    className
  );

  const classNamesIconWrapper = clsx(styles['information__iconWrapper'], {
    [styles['information__iconWrapper--iconError']]: icon === 'error',
  });
  const renderIcon = () => {
    switch (icon) {
      case 'info':
        return <Info />;
      case 'check':
        return <Check />;
      case 'error':
        return <Info />;
      case 'none':
        return null;
    }
  };

  return (
    <div className={classNames}>
      {icon !== 'none' && (
        <div className={classNamesIconWrapper}>{renderIcon()}</div>
      )}
      <p>{children}</p>
    </div>
  );
};
